import Vue from 'vue'
import Vuex from 'vuex'
import juniperAPI from '../api/juniperApi'
import restApi from '../api/index'

import { decode } from 'jsonwebtoken'
import router from '../router'

Vue.use(Vuex)

// production API Endpoint
let apiUrl = 'http://127.0.0.1:8000/api'
let storageUrl = 'http://127.0.0.1:8000/storage'
let avatarUrl = 'images/avatar.png'

// Juniper API
let juniperApiUrl = 'http://127.0.0.1:8001/api'
let juniperStorageUrl = 'http://127.0.0.1:8001/storage'

// guess Api endpoint for current environment
if (location.hostname === 'mc2.townweb.com' || location.hostname === 'mc.townweb.com' || location.hostname.endsWith('.missioncontrol2.pages.dev')) {
	apiUrl = 'https://mc2api.townweb.com/api'
	storageUrl = 'https://mc2api.townweb.com/storage'
}

export default new Vuex.Store({
	state: {
		juniperApiUrl,
		juniperStorageUrl,
		apiUrl,
		storageUrl,
		avatarUrl,
		token: localStorage.getItem('auth-token') || null,
		tokenJuniper: localStorage.getItem('auth-token-juniper') || null,
		authUser: decode(localStorage.getItem('auth-token')) || null,
		authUserJuniper: JSON.parse(localStorage.getItem('auth-user-juniper')) || null,
		account: null,
		menuOpen: false,
		sidebarCollapsed: localStorage.getItem('sidebar-collapsed') === 'true' || false,
		dashboardDark: localStorage.getItem('dashboard-dark') === 'true' || false,
		juniperApiToken: '1CahiXUsrwICLzZsnk19Va1cP',
		// Who can be credited as project manager on a Juniper client — a short
		// whitelist served by mc2-api, fetched once per session.
		projectManagers: [],
		projectManagersLoading: false,
	},
	getters: {
		isAuth(state) {
			if (state.token) {
				return true
			} else {
				return false
			}
		},
		authUser(state) {
			return state.authUser
		},
		tokenJuniper(state) {
			return state.tokenJuniper
		},
		// id -> project manager, for resolving a stored project_manager_id to a name.
		projectManagerById(state) {
			return state.projectManagers.reduce((map, user) => {
				map[user.id] = user
				return map
			}, {})
		},
	},
	mutations: {
		SET_TOKEN(state, token) {
			localStorage.setItem('auth-token', token)
			state.token = token
		},

		SET_AUTH(state, token) {
			localStorage.setItem('auth-token', token)
			state.token = token
			state.authUser = decode(state.token)
		},

		SET_AUTH_JUNIPER(state, token) {
			localStorage.setItem('auth-token-juniper', token)
			state.tokenJuniper = token
		},

		SET_AUTH_USER_JUNIPER(state, user) {
			localStorage.setObject('auth-user-juniper', user)
			state.authUserJuniper = user
		},

		SET_ACCOUNT(state, account) {
			state.account = account
		},

		UNSET_AUTH(state) {
			state.token = null
			state.authUser = null
		},

		UNSET_AUTH_JUNIPER(state) {
			state.tokenJuniper = null
		},

		UNSET_AUTH_USER_JUNIPE(state) {
			state.authUserJuniper = null
		},

		TOGGLE_MENU(state, open) {
			if (open === undefined) {
				open = !state.menuOpen
			}
			state.menuOpen = open
		},

		TOGGLE_SIDEBAR_COLLAPSE(state) {
			state.sidebarCollapsed = !state.sidebarCollapsed
			localStorage.setItem('sidebar-collapsed', state.sidebarCollapsed.toString())
		},

		SET_DASHBOARD_DARK(state, value) {
			state.dashboardDark = value
			localStorage.setItem('dashboard-dark', state.dashboardDark.toString())
		},

		SET_PROJECT_MANAGERS(state, projectManagers) {
			state.projectManagers = projectManagers
		},

		SET_PROJECT_MANAGERS_LOADING(state, loading) {
			state.projectManagersLoading = loading
		},
	},
	actions: {
		authLogin: ({ commit, dispatch }, user) => {
			return new Promise((resolve, reject) => {
				restApi
					.post('login', user)
					.then(resp => {
						// This is a successful authentication
						if (resp.data.error) {
							localStorage.removeItem('auth-token')
							reject(resp.data.error)
						} else {
							commit('SET_AUTH', resp.data.token)
							dispatch('accountInfo')
							resolve(resp)
						}
					})
					.catch(error => {
						localStorage.removeItem('auth-token')
						reject(error)
					})
			})
		},

		authLoginJuniper: ({ commit }, login) => {
			return new Promise((resolve, reject) => {
				juniperAPI
					.post('auth', login)
					.then(resp => {
						// This is a successful authentication
						if (resp.data.error) {
							localStorage.removeItem('auth-token-juniper')
							localStorage.removeItem('auth-user-juniper')
							reject(resp.data.error)
						} else {
							commit('SET_AUTH_JUNIPER', resp.data.response.access_token)
							commit('SET_AUTH_USER_JUNIPER', resp.data.user)
							resolve(resp)
						}
					})
					.catch(error => {
						localStorage.removeItem('auth-token-juniper')
						localStorage.removeItem('auth-user-juniper')
						reject(error)
					})
			})
		},

		authLoginSocialite: (user, provider) => {
			return new Promise((resolve, reject) => {
				restApi
					.get('login/' + provider, user)
					.then(resp => {
						resolve(resp.data)
					})
					.catch(error => {
						reject(error)
					})
			})
		},

		authLogout: ({ commit }, token) => {
			return new Promise((resolve, reject) => {
				restApi
					.post('logout', token)
					.then(() => {
						// This is a successful logout
						commit('UNSET_AUTH')
						localStorage.removeItem('auth-token')
						localStorage.removeItem('auth-token-juniper')
						localStorage.removeItem('auth-user-juniper')
						resolve()
						router.push('/login')
						window.location.reload()
					})
					.catch(error => {
						reject(error)
					})
			})
		},

		refreshToken: () => {
			return new Promise((resolve, reject) => {
				restApi
					.post(`token/refresh`)
					.then(response => {
						resolve(response)
					})
					.catch(error => {
						reject(error)
					})
			})
		},

		accountInfo: ({ commit, state }) => {
			if (state.account === null && state.token) {
				restApi.get(`user/${state.authUser.id}`).then(resp => {
					commit('SET_ACCOUNT', resp.data)
				})
			}
		},

		// Load the project-manager whitelist once — both the clients list and the
		// client edit page need it to turn a project_manager_id into a name, and
		// it barely changes. The loading flag guards concurrent callers on mount.
		fetchProjectManagers: ({ commit, state }) => {
			if (state.projectManagers.length || state.projectManagersLoading) {
				return Promise.resolve(state.projectManagers)
			}

			commit('SET_PROJECT_MANAGERS_LOADING', true)

			return restApi
				.get('users/project-managers')
				.then(resp => {
					commit('SET_PROJECT_MANAGERS', resp.data)
					return resp.data
				})
				.catch(() => [])
				.finally(() => {
					commit('SET_PROJECT_MANAGERS_LOADING', false)
				})
		},

		accountUpdate: ({ commit, state }, account) => {
			return new Promise((resolve, reject) => {
				restApi
					.put(`user/${state.authUser.id}`, account)
					.then(resp => {
						commit('SET_ACCOUNT', resp.data)
						resolve(resp)
					})
					.catch(error => {
						reject(error)
					})
			})
		},
	},
})
